<script setup>
import '~/assets/styles/tiptap.scss'
import html2pdf from 'html2pdf.js'

const { t } = useI18n()
const route = useRoute('reports-id')

const { data: doc } = await apiShow('project-documents', route.params.id, {
	defaultQuery: {
		relations: 1,
	},
})

const project = doc.value.project
const objects = doc.value.objects
const reports = doc.value.reports
const prescriptions = doc.value.prescriptions
const workTypeStatistics = doc.value.work_stats
const checklists = doc.value.checklists
const workTypes = doc.value.works

if (!doc.value.content) {
	doc.value.content = componentToString(resolveComponent('ProjectDocumentTemplate'), {
		doc: toValue(doc),
		project,
		reports,
		objects,
		workTypeStatistics,
		workTypes,
		prescriptions,
		checklists,
		t,
	})
}

function downloadPdf() {
	const element = document.querySelector('#document-content')

	html2pdf()
		.set({
			margin: 10,
			filename: `${doc.value.title || 'document'}.pdf`,
			html2canvas: { scale: 2 },
			jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
		})
		.from(element)
		.save()
}
</script>

<template>
	<div style="background: #fff; width: 900px; margin: auto" id="document-content">
		<div style="padding: 20px 20px 20px 80px">
			<table width="100%" v-if="doc">
				<tbody>
					<tr>
						<td v-html="doc.content" class="print-content"></td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
definePageMeta({
	layout: false,
})
</script>
